import {createSelector} from 'reselect';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings],
  settings => settings.requires_site_t_and_c_consent_info_msg,
);
